/**
 * 密码策略（明文校验，提交前再 MD5）
 * 规则：长度 ≥ 6；须含数字；且含字母或特殊符号
 */
export const PASSWORD_RULE_TIP = '密码须包含数字，并包含字母或特殊符号，最少 6 位'

export const PASSWORD_REG = /^(?=.*\d)((?=.*[A-Za-z])|(?=.*[^A-Za-z0-9])).{6,}$/

export function validatePasswordPlain(password) {
  if (!password || typeof password !== 'string') {
    return false
  }
  return PASSWORD_REG.test(password)
}

/** 从登录 Token / userInfo 中解析改密策略字段（兼容 additionalInformation） */
export function extractPasswordPolicy(data) {
  if (!data || typeof data !== 'object' || Array.isArray(data)) {
    return {
      forceChangePassword: 0,
      passwordExpired: false,
      passwordExpireDays: 0
    }
  }
  const extra = data.additionalInformation && typeof data.additionalInformation === 'object'
    ? data.additionalInformation
    : {}
  const src = { ...extra, ...data }
  const expired = src.password_expired
  return {
    forceChangePassword: Number(src.force_change_password) === 1 ? 1 : 0,
    passwordExpired: expired === true || expired === 'true' || expired === 1 || expired === '1',
    passwordExpireDays: Number(src.password_expire_days) || 0
  }
}

export function isNeedChangePassword(policy) {
  if (!policy) {
    return false
  }
  return Number(policy.forceChangePassword) === 1 || policy.passwordExpired === true
}

/** Element UI 表单：新密码规则校验器 */
export function createNewPasswordValidator(getOldPassword) {
  return (rule, value, callback) => {
    if (!value) {
      callback(new Error('新密码不能为空'))
      return
    }
    if (!validatePasswordPlain(value)) {
      callback(new Error(PASSWORD_RULE_TIP))
      return
    }
    if (typeof getOldPassword === 'function') {
      const oldPassword = getOldPassword()
      if (oldPassword && value === oldPassword) {
        callback(new Error('新密码不能与当前密码相同'))
        return
      }
    }
    callback()
  }
}
